export const TOGGLE_NAV_COLLAPSED = 'TOGGLE_NAV_COLLAPSED';
export const toggleNavCollapsed = () => ({ type: TOGGLE_NAV_COLLAPSED });

// Notifications actions
export const UPDATE_NAVIGATION_BADGE = 'UPDATE_NAVIGATION_BADGE';
export const updateNavigationBadge = (badge) => ({
	type: UPDATE_NAVIGATION_BADGE,
	payload: badge
});

export const NOTIFICATIONS_CONNECT = 'NOTIFICATIONS_CONNECT';
export const connectToNotifications = () => ({ type: NOTIFICATIONS_CONNECT });

export const NOTIFICATIONS_DISCONNECT = 'NOTIFICATIONS_DISCONNECT';
export const disconnectNotifications = (client) => ({
	type: NOTIFICATIONS_DISCONNECT,
	payload: client
});
